<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>
        <v-list-item v-for="item in items" :key="item.text" link :to="item.to">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider v-if="haveManagementMenu" inset></v-divider>
        <v-subheader v-if="haveManagementMenu" inset>Management</v-subheader>

        <template v-for="item in managementItems">
          <v-list-item v-if="$accessable(item.required) && !item.hidden" :key="item.text" link :to="item.to">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-group prepend-icon="mdi-rocket-launch" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Token Campaign Manager</v-list-item-title>
            </v-list-item-content>
          </template>
          
          <v-list-item link to="/campaign-manager">
            <v-list-item-action>
              <v-icon>mdi-rocket</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Campaign Manager</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/campaign-analytics">
            <v-list-item-action>
              <v-icon>mdi-chart-box</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Campaign Analytics</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/campaign-settings">
            <v-list-item-action>
              <v-icon>mdi-cog-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Campaign Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/user-token-manager">
            <v-list-item-action>
              <v-icon>mdi-wallet</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>User Token Manager</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/token-rate-manager">
            <v-list-item-action>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Token Rate Manager</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        
        <!-- <v-subheader class="mt-4 grey--text text--darken-1">SUBSCRIPTIONS</v-subheader>
        <v-list>
          <v-list-item v-for="item in items2" :key="item.text" link>
            <v-list-item-avatar>
              <img :src="`https://randomuser.me/api/portraits/men/${item.picture}.jpg`" alt="">
            </v-list-item-avatar>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item>
        </v-list> -->
        <!-- <v-list-item class="mt-4" link>
          <v-list-item-action>
            <v-icon color="grey darken-1">mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title class="grey--text text--darken-1">Browse Channels</v-list-item-title>
        </v-list-item> -->

        <v-list-group prepend-icon="mdi-cog" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-divider inset></v-divider>
          <v-subheader inset>Banner</v-subheader>
          <!-- Sub Items -->
          <v-list-item link to="/settings/sidebar-banner">
            <v-list-item-content>
              <v-list-item-title>Sidebar Banner</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/settings/mobile-banners">
            <v-list-item-content>
              <v-list-item-title>Mobile Banner</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/settings/mobile-mini-banner">
            <v-list-item-content>
              <v-list-item-title>Toluna Banner</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider inset></v-divider>
          <v-subheader inset>Other</v-subheader>

          <v-list-item link to="/settings/listing-settings">
            <v-list-item-content>
              <v-list-item-title>Listing Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/settings/community-filters">
            <v-list-item-content>
              <v-list-item-title>Community Filters</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- Sub Items End -->
        </v-list-group>

        <!-- <v-list-item link>
          <v-list-item-action>
            <v-icon color="grey darken-1">mdi-cog</v-icon>
          </v-list-item-action>
          <v-list-item-title class="grey--text text--darken-1">Manage Settings</v-list-item-title>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left color="#212529" dense dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <!-- <v-icon class="mx-4" large>mdi-youtube</v-icon> -->
      <v-toolbar-title class="mr-12 align-center d-none d-md-flex">
        <!-- <span class="title">Breaking HITS CMS</span> -->
        <span class="title">
          <img :src="require('../../assets/breaking-hits-logo.png')" height="35" style="margin-top: 8px;" />
        </span>
      </v-toolbar-title>
      <div class="d-none d-md-flex" style="width: 50px;"></div>
      <div class="d-md-none d-lg-none d-xl-none">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item-group @change="onHeaderMenuChange">
              <v-list-item>
                <v-list-item-icon style="margin: 10px 0; margin-right: 18px;"><v-icon>mdi-account-music</v-icon></v-list-item-icon>
                <v-list-item-title>Artists</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon style="margin: 10px 0; margin-right: 18px;"><v-icon>mdi-chart-histogram</v-icon></v-list-item-icon>
                <v-list-item-title>Labels</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon style="margin: 10px 0; margin-right: 18px;"><v-icon>mdi-account-group</v-icon></v-list-item-icon>
                <v-list-item-title>Groups</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>

      <v-row class="d-none d-md-flex">
        <v-btn class="ma-1" text @click="onHeaderMenuChange(0)">
          <v-icon left dark>
            mdi-account-music
          </v-icon>
          Artists
        </v-btn>
        <v-btn class="ma-1" text @click="onHeaderMenuChange(1)">
          <v-icon left dark>
            mdi-chart-histogram
          </v-icon>
          Labels
        </v-btn>
        <v-btn class="ma-1" text @click="onHeaderMenuChange(2)">
          <v-icon left dark>
            mdi-account-group
          </v-icon>
          Groups
        </v-btn>
      </v-row>
      <v-spacer></v-spacer>

      <v-btn icon>
        <v-badge color="red" content="6" overlap>
          <v-icon dark>mdi-bell</v-icon>
        </v-badge>
      </v-btn>

      <div style="width: 10px;"></div>

      <v-divider inset vertical></v-divider>

      <v-menu offset-y>
         <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" text>
            <!-- <v-icon>mdi-dots-vertical</v-icon> -->
            <div style="margin-right: 10px; text-align: end;">
              <span style="font-size: 8pt; text-transform: capitalize; color: rgba(255, 255, 255, 0.38);">Welcome,</span><br />
              <span style="text-transform: capitalize; font-size: 10pt; color: rgba(255, 255, 255, 0.6);">
                {{ user.fname }} {{ user.lname }}
              </span>
            </div>
            <v-avatar color="primary" size="35">
              <img :src="user.profile_picture" />
            </v-avatar>
          </v-btn>
        </template>

        <v-list>
          <v-list-item-group @change="onMainMenuChange">
            <v-list-item style="min-height: 45px;">
              <v-list-item-icon style="margin: 10px 0; margin-right: 18px;"><v-icon>mdi-account</v-icon></v-list-item-icon>
              <v-list-item-title>My Profile</v-list-item-title>
            </v-list-item>
            <v-list-item style="min-height: 45px;">
              <v-list-item-icon style="margin: 10px 0; margin-right: 18px;"><v-icon>mdi-cog</v-icon></v-list-item-icon>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item>
            <v-list-item style="min-height: 45px;">
              <v-list-item-icon style="margin: 10px 0; margin-right: 18px;"><v-icon>mdi-cloud-upload</v-icon></v-list-item-icon>
              <v-list-item-title>Upload</v-list-item-title>
            </v-list-item>
            <v-list-item style="min-height: 45px;">
              <v-list-item-icon style="margin: 10px 0; margin-right: 18px;"><v-icon>mdi-help-circle</v-icon></v-list-item-icon>
              <v-list-item-title>Help</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item style="min-height: 45px;">
              <v-list-item-icon style="margin: 10px 18px 10px 0px;"></v-list-item-icon>
              <v-list-item-title>Sign Out</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <!-- <v-row align="center" style="max-width: 650px">
        <v-text-field :append-icon-cb="() => {}" placeholder="Search..." single-line append-icon="mdi-magnify" color="white" hide-details></v-text-field>
      </v-row> -->
    </v-app-bar>

    <v-main style="background-color: #f2f2f6;">
        <!-- <v-container class="fill-height"> -->
        <v-container fliud>
            <v-row justify="start" align="center">
                <v-col>
                    <router-view></router-view>
                </v-col>
            </v-row>

        <!-- <v-row justify="center" align="center">
          <v-col class="shrink">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn :href="source" icon large target="_blank" v-on="on">
                  <v-icon large>mdi-code-tags</v-icon>
                </v-btn>
              </template>
              <span>Source</span>
            </v-tooltip>
          </v-col>
        </v-row> -->

      </v-container>
      <br />
      <br />
      <br />
      <v-footer color="rgb(242, 242, 246)" absolute padless>
        <v-card color="transparent" flat tile style="width: 100%; margin-left: 20px; margin-right: 20px;">
          <v-divider></v-divider>
          <v-card-text>
            <span style="color: rgba(0, 0, 0, 0.7); font-size: 10pt;">Breaking Hits Inc. {{ currentYear }} ©All rights reserved.</span>
          </v-card-text>
        </v-card>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    props: {
        source: String,
    },
    data: () => ({
        drawer: null,
        items: [
            {
                icon: 'mdi-view-dashboard-variant-outline',
                text: 'Dashboard',
                to: '/dashboard'
            },
        ],
        managementItems: [
            {
              icon: 'mdi-account-music',
              text: 'Feature Music Manager',
              to: 'label-campaign-manager',
              required: []
            },
            {
              icon: 'mdi-music',
              text: 'Music Upload',
              to: 'music-lists',
              required: []
            },
            {
                icon: 'mdi-star',
                text: 'Points Manager',
                to: '/points-manager',
                required: []
            },
            {
              icon: 'mdi-database-settings-outline',
              text: 'Items/Marketplace Manager',
              to: 'item-marketplace-database',
              required: []
            },
            // Push Notification Manager
            {
                icon: 'mdi-bell',
                text: 'Push Notification Manager',
                to: '/push-notification-manager',
                required: []
            },
            {
                icon: 'mdi-email',
                text: 'Email Template Manager',
                to: '/email-template-manager',
                required: []
            },
            {
                icon: 'mdi-file-star',
                text: 'Quest Manager',
                to: '/quest-manager',
                required: []
            },
            {
                icon: 'mdi-gamepad-variant',
                text: 'EXP Tables Manager',
                to: '/exp-tables-manager',
                required: []
            },
            {
              icon: 'mdi-qrcode',
              text: 'Promo Code Manager',
              to: 'promo-code-manager',
              required: []
            },
            {
                icon: 'mdi-format-list-text',
                text: 'Survey Manager',
                to: '/survey-manager',
                required: ['bhSurveyOptionsCreate', 'bhSurveyOptionTreeCreate']
            },
            {
                icon: 'mdi-rocket',
                text: 'Campaign Manager',
                to: '/campaign-manager',
                required: [],
                hidden: true
            },
            {
                icon: 'mdi-account-group-outline',
                text: 'Group Settings',
                to: '/group-settings',
                required: []
            },
            {
                icon: 'mdi-account-star-outline',
                text: 'Individual Campaign Settings',
                to: '/individual-campaign-settings',
                required: []
            },
            {
                icon: 'mdi-cog-outline',
                text: 'Campaign Settings',
                to: '/campaign-settings',
                required: [],
                hidden: true
            },
            {
                icon: 'mdi-wallet',
                text: 'User Token Manager',
                to: '/user-token-manager',
                required: [],
                hidden: true
            },
            // {
            //     icon: 'mdi-flower-pollen',
            //     text: 'Toluna',
            //     to: '/toluna-manager',
            //     required: []
            // },
            {
                icon: 'mdi-account-multiple',
                text: 'User & Roles Manager',
                to: '/roles-manager',
                required: ['usersCreate', 'usersRemove', 'serviceLists']
            },
            {
                icon: 'mdi-account',
                text: 'Pending Signup Users',
                to: '/pending-signup-users',
                required: []
            },
            {
                icon: 'mdi-folder-account',
                text: 'Profile Templates',
                to: '/profile-templates',
                required: []
            },
            {
                icon: 'mdi-puzzle',
                text: 'Logic Control',
                to: '/logic-control',
                required: ['apiLists']
            },
            {
                icon: 'mdi-toy-brick-outline',
                text: 'API Access Manager',
                to: '/api-control',
                required: ['apiLists']
            },
            {
                icon: 'mdi-microsoft-access',
                text: 'Access Control Manager',
                to: '/access-control',
                required: ['serviceLists']
            },
        ]
    }),
    computed: {
      haveManagementMenu() {
        return this.managementItems.filter(item => this.$accessable(item.required)).length !== 0;
      },
      currentYear() {
        return new Date().getFullYear();
      },
      ...mapState('auth', ['user'])
    },
    created () {
        this.$vuetify.theme.dark = false;
    },
    methods: {
      async onHeaderMenuChange(index) {
        try {
          switch(index) {
            case 0:
              await this.$router.push('/artists-manager');
              break;
            case 1:
              await this.$router.push('/labels-lists');
              break;
            case 2:
              await this.$router.push('/groups-lists');
              break;
          }
        } catch(err) {
          return;
        }
      },
      async onMainMenuChange(index) {
        switch(index) {
          case 0: // My Profile

            break;
          case 1: // Settings

            break;
          case 2: // Upload

            break;
          case 3: // Help

            break;
          case 4: // Sign Out
            await this.logout();
            this.$router.push('/login');
            break;
        }
      },
      ...mapActions('auth', ['logout'])
    },
}
</script>